import { render, staticRenderFns } from "./CategoryGroup.vue?vue&type=template&id=e1854cc8"
import script from "./CategoryGroup.vue?vue&type=script&lang=js"
export * from "./CategoryGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports